/**
 * Admin Services
 */

angular.module("open-iti")

	.factory("OpenFormUserService", ["$resource", "$http", "SharedProperties", "CONSTANTS", "ENV", function ($resource, $http, SharedProperties, CONSTANTS, ENV) {


		/**
     * API
     */
		return {
			getSubscribersUser: getSubscribersUser,
			getSubscriberUser : getSubscriberUser
		};


		function getSubscribersUser() {
			return $http.get(ENV.API_URL + "/open-data/user");
		}

		function getSubscriberUser(id) {
			return $http.get(ENV.API_URL + "/open-data/user/"+id);
		}


	}
	]);

